import { render } from "./UserDropdown.vue?vue&type=template&id=714933d2"
import script from "./UserDropdown.vue?vue&type=script&lang=js"
export * from "./UserDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script